export default "__VITE_ASSET__DVHIBnLi__"